/**
 * Operational run status badge for the S6 catalog.
 */

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import type { StudioRunStatus } from '@/types/aiStudioAgent';

const STATUS_CLASSES: Record<StudioRunStatus, string> = {
  open: 'border-[var(--color-info)] text-[var(--color-info)]',
  in_progress: 'border-[var(--color-success)] text-[var(--color-success)]',
  paused: 'border-[var(--color-warning)] text-[var(--color-warning)]',
  completed: 'border-[var(--color-success)] text-[var(--color-success)]',
  archived: 'border-[var(--color-border)] text-[var(--color-surface-text-secondary)]',
  cancelled: 'border-[var(--color-error)] text-[var(--color-error)]',
};

interface RunStatusBadgeProps {
  status: StudioRunStatus;
}

export const RunStatusBadge: React.FC<RunStatusBadgeProps> = ({ status }) => {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-block rounded-full border px-2 py-0.5 text-base ${STATUS_CLASSES[status]}`}
    >
      {t(`aiStudio.runStatus.${status}`)}
    </span>
  );
};
